import React from 'react';
import styled from 'styled-components';
import { StandardProperties } from 'csstype';
import { motion, HTMLMotionProps } from 'framer-motion';
import { devices } from '../../util/cssMediaQuery.util';
import { formWidth } from './Constants';

const Content = styled(motion.div)`
  display: grid;
  height: 100%;
  width: calc(100vw - 40px);
  grid-template-rows: ${(props: CenteredContentProps) =>
    props.$gridTemplateRows ?? 'auto auto auto 1fr'};
  align-items: ${(props: CenteredContentProps) => props.$align};

  ${devices.mobileM} {
    width: calc(100vw - 80px);
  }
  ${devices.tablet} {
    width: ${formWidth.tablet};
  }

  color: #000000;
  h2 {
    font-weight: 700;
    font-size: 28px;
    line-height: 42px;
  }
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin-block-start: 0;
    margin-block-end: 28px;
  }
`;

interface CenteredContentProps extends HTMLMotionProps<'div'> {
  id: string;
  children: React.ReactNode;
  $gridTemplateRows?: string;
  $align?: StandardProperties['alignItems'];
}

export const CenteredContent: React.FunctionComponent<
  CenteredContentProps
> = props => {
  const { id, className, children, style, $align, $gridTemplateRows } = props;
  return (
    <Content
      id={id}
      className={className} // attaches the 'styled-components' style
      data-testid={id}
      style={style}
      $align={$align}
      $gridTemplateRows={$gridTemplateRows}
    >
      {children}
    </Content>
  );
};

export default CenteredContent;
